import { render, staticRenderFns } from "./Laboratorio.vue?vue&type=template&id=ee35f20e"
import script from "./Laboratorio.vue?vue&type=script&lang=js"
export * from "./Laboratorio.vue?vue&type=script&lang=js"
import style0 from "./Laboratorio.vue?vue&type=style&index=0&id=ee35f20e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports